import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import ArticleCarouselCard, { ArticleCarouselCardProps } from '../ArticleCarouselCard/ArticleCarouselCard';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './ArticleCarousel.module.scss';

interface CarouselProps {
  logoUrl?: string;
  cards: ArticleCarouselCardProps[]; // Ensure proper typing
  isMobile?: boolean;
}

const FilterCarousel: React.FC<CarouselProps> = ({ logoUrl, cards = [], isMobile }) => {
  const sliderRef = useRef<Slider>(null);

  const { t } = useTranslation();

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0); // Reset to the first slide when isMobile changes
    }
  }, [isMobile]);

  const settings = {
    infinite: false,
    speed: 500,
    // slidesToShow: isMobile ? 1 : 3,
    variableWidth: true,
    dots: false,
    afterChange: (current: number) => {
      setCurrentSlide(current);
      if (sliderRef.current) {
        const totalSlides = React.Children.count(sliderRef.current?.props.children);
        const visibleSlides = 1;
        setIsEnd(current >= totalSlides - visibleSlides);
      }
    },
    onInit: () => {
      setCurrentSlide(0);
      setIsEnd(false);
    },
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  return (
    <>
      <div className={`${styles['header-container']}`}>
        <div className={`${styles['title-container']}`}>
          {t('dashboard.home.label.latestBy')}
          <img src={logoUrl} alt={'Logo'} className={styles['title-logo']} />
        </div>
        <div className={`${styles['button-container']}`}>
          <button
            className={`${styles['arrowButton']} ${currentSlide === 0 ? styles['disabled'] : ''}`}
            onClick={handlePrev}
            disabled={currentSlide === 0}
          >
            <i className="fa fa-angle-left" aria-hidden="true"></i>
          </button>
          <button
            className={`${styles['arrowButton']} ${isEnd ? styles['disabled'] : ''}`}
            onClick={handleNext}
            disabled={isEnd}
          >
            <i className="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <Slider ref={sliderRef} className={styles.carousel} {...settings}>
        {cards.map((card, index) => (
          <div
            key={index}
            className={`${styles['carousel-item']} ${index === 0 ? styles['ml-0'] : ''}`}
          >
            <ArticleCarouselCard
              translation={t}
              imageSrc={card.imageSrc}
              label={card.label}
              title={card.title}
              date={card.date}
              redirectUrl={card.redirectUrl}
              views={card?.views}
              categoryColor={card?.categoryColor}
            />
          </div>
        ))}
      </Slider>
    </>
  );
};

export default FilterCarousel;
